import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

import TitleWrap from "@atoms/TitleWrap";

import useMeta from "@hooks/reducerHooks/useMeta";

function ShippingInformation() {
  const { setMetaTag } = useMeta();

  const { t } = useTranslation();

  useEffect(() => {
    setMetaTag({ title: `TUNE.KR - SHIPPING INFORMATION` });
  }, []);

  return (
    <TitleWrap className="tune-column-4 flex flex-col gap-5 leading-relax" title={t("pages.shipping.title")}>
      <strong>{t("pages.shipping.description")}</strong>
      <ul className="list-outside list-none font-regular">
        <li>• {t("pages.shipping.shipping_fee")}</li>
        <li>• {t("pages.shipping.shipping_period")}</li>
        <li>• {t("pages.shipping.shipping_description1")}</li>
        <li>• {t("pages.shipping.shipping_description2")}</li>
      </ul>
    </TitleWrap>
  );
}

export default ShippingInformation;
